import { z } from "zod";

export const getVehiclesSivDataListByCompanyRequest = z.object({
  companyUuid: z.uuid(),
});

export type GetVehiclesSivDataListByCompanyRequest = z.infer<
  typeof getVehiclesSivDataListByCompanyRequest
>;
